/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'

const http ={
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    get(url,params){
        const config = {
            method: 'get',
            url:url,
            dataType:'json',
            headers:{'Content-Type':"application/x-www-form-urlencoded;charset=utf-8"}
        }
        if(params) config.params = params
        return request(config)
    },
    post(url,params){
        const config = {
            method: 'post',
            url:url,
            dataType:'json',
            headers:{'Content-Type':"application/json;charset=utf-8"}
        }
        if(params){
            config.data = params
            config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
        }
        return request(config)
    },
    postParams(url,params){
        const config = {
            method: 'post',
            url:url,
            dataType:'json',
            headers:{'Content-Type':"application/x-www-form-urlencoded;charset=utf-8"}
        }
        if(params){
            // config.data = params
         
            config.params = params ; //数据转化,也可以使用qs转换
        }
        return request(config)
    },
    put(url,params){
        const config = {
            method: 'put',
            url:url
        }
        if(params) config.params = params
        return request(config)
    },
    delete(url,params){
        const config = {
            method: 'delete',
            url:url
        }
        if(params) config.params = params
        return request(config)
    }
}
//导出
export default http



// WEBPACK FOOTER //
// ./src/utils/http.js